import styled from 'styled-components'
import {
  Box,
  TableCell,
  TableHead as TableHeadMUI,
  TableRow,
  TableSortLabel,
} from '@mui/material'
import { visuallyHidden } from '@mui/utils'

const StickyTableCell = styled(TableCell)`
  min-width: 50px;
  left: 0;
  position: sticky;
  z-index: 2;
  background-color: #fff;
`

const Sticky = ({ children, ...props }) => {
  return <StickyTableCell {...props}>{children}</StickyTableCell>
}

const TableHead = ({
  order,
  orderBy,
  onRequestSort,
  headCells,
  groupingTable,
  ...props
}) => {
  const createSortHandler = property => event => {
    onRequestSort(event, property)
  }

  return (
    <TableHeadMUI>
      {groupingTable}
      <TableRow>
        {headCells.map(headCell => (
          <>
            {headCell.sticky ? (
              <Sticky
                key={headCell.id}
                align={headCell.align}
                padding={headCell.disablePadding ? 'none' : 'normal'}
                sortDirection={orderBy === headCell.id ? order : false}
              >
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : 'asc'}
                  onClick={createSortHandler(headCell.id)}
                  sx={{ color: '#757575' }}
                >
                  {headCell.label}
                  {orderBy === headCell.id ? (
                    <Box
                      component='span'
                      sx={visuallyHidden}
                    >
                      {order === 'desc'
                        ? 'sorted descending'
                        : 'sorted ascending'}
                    </Box>
                  ) : null}
                </TableSortLabel>
              </Sticky>
            ) : (
              <TableCell
                key={headCell.id}
                align={headCell.align}
                padding={headCell.disablePadding ? 'none' : 'normal'}
                sortDirection={orderBy === headCell.id ? order : false}
                sx={{
                  borderColor: headCell.notSort ? '#FFF' : '#e0e0e0',
                  ...props?.sxx,
                }}
              >
                {headCell.notSort ? (
                  <></>
                ) : (
                  <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : 'asc'}
                    onClick={createSortHandler(headCell.id)}
                    sx={{ color: '#757575' }}
                  >
                    {headCell.label}
                    {orderBy === headCell.id ? (
                      <Box
                        component='span'
                        sx={visuallyHidden}
                      >
                        {order === 'desc'
                          ? 'sorted descending'
                          : 'sorted ascending'}
                      </Box>
                    ) : null}
                  </TableSortLabel>
                )}
              </TableCell>
            )}
          </>
        ))}
      </TableRow>
    </TableHeadMUI>
  )
}

export default TableHead
